// BETA VERSION: Stripe service disabled for beta testing
// This service is preserved for future payment integration
// To re-enable: Remove this comment and ensure Stripe keys are configured

export interface CreateCheckoutSessionParams {
  planType: string;
  workspaceId: string;
  workspaceSlug: string;
  customerEmail: string;
  purchaseType?: 'subscription' | 'ai_credits';
  creditsAmount?: number;
}

export interface CreatePortalSessionParams {
  customerId: string;
}

export class StripeService {
  /**
   * BETA: Stripe checkout disabled - returns mock response
   */
  static async createCheckoutSession(params: CreateCheckoutSessionParams) {
    return 'beta_mock_session_id';
  }

  /**
   * BETA: Stripe portal disabled - returns mock URL
   */
  static async createPortalSession(params: CreatePortalSessionParams) {
    return 'https://beta.wattfactory.tech/beta-billing';
  }

  /**
   * BETA: Stripe billing disabled - returns mock billing info
   */
  static async getWorkspaceBilling(workspaceId: string) {
    return {
      customerId: 'beta_mock_customer',
      subscriptionId: 'beta_mock_subscription',
      planType: 'free',
      status: 'active',
      currentPeriodEnd: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(), // 30 days from now
      cancelAtPeriodEnd: false
    };
  }

  /**
   * BETA: Stripe redirect disabled - shows beta message
   */
  static async redirectToCheckout(sessionId: string) {
    // In beta, show a toast instead of redirecting
    console.log('BETA: Stripe checkout disabled - would redirect to:', sessionId);
    // You could add a toast notification here if needed
    return false;
  }

  // ORIGINAL CODE BELOW (disabled for beta)
  /*
  static async createCheckoutSession(params: CreateCheckoutSessionParams) {
    try {
      // Use Supabase Edge Function instead of local API route
      const { data, error } = await supabase.functions.invoke('create-checkout-session', {
        body: params
      });

      if (error) {
        throw new Error(error.message || 'Failed to create checkout session');
      }

      return data.sessionId;
    } catch (error) {
      console.error('Error creating checkout session:', error);
      throw error;
    }
  }

  static async createPortalSession(params: CreatePortalSessionParams) {
    try {
      const response = await fetch('/api/stripe/create-portal-session', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
      });

      if (!response.ok) {
        throw new Error('Failed to create portal session');
      }

      const data = await response.json();
      return data.url;
    } catch (error) {
      console.error('Error creating portal session:', error);
      throw error;
    }
  }
  */
} 